import React from 'react';
import { DataList, createInitialFilters } from 'commons-ui';

import useDashboardActions from 'pages/dashboard/useDashboardActions';
import { LIST_ENTITY_NAMES } from 'constant';

import useService from '../../utils/useService';
import { makeActionHandler } from '../../actions/handlers';
import { makeActionList } from '../../actions/list';
import { activeFilter, columnConfigs } from './listConfig';

const BannerList: React.FC<{}> = () => {
	const { getActionHandler, getActionList } = useDashboardActions(makeActionHandler, makeActionList);
	const actions = getActionList();

	const { getBannersData } = useService();

	return (
		<DataList
			fetchData={getBannersData}
			columnConfigs={columnConfigs}
			getActionHandler={getActionHandler}
			actions={actions}
			rowHeight={100}
			entity={LIST_ENTITY_NAMES.BANNERS}
			initialFilters={createInitialFilters(activeFilter)}
			initialSortDirection='ASC'
			initialSortIndex={1}
		/>
	);
};

export default BannerList;
